module.exports = __webpack_public_path__ + "img/logo-florestabranco-xs.ff0099ed.png";